import { isArrayLikeObject, isEmpty, isNumber } from 'lodash';
import moment from 'moment-timezone';

export const isNotNullOrUndefined = (obj) => {
    if (obj !== undefined && obj !== null) {
        return true;
    }

    return false;
};

export const isNullOrUndefined = (obj) => {
    if (obj === undefined || obj === null) {
        return true;
    }

    return false;
};

export const isStringEmpty = (value) => {
    if (value === undefined || value === null || value === '') {
        return true;
    }

    return false;
};

export const isStringNotEmpty = (value) => {
    if (isNotNullOrUndefined(value) && value !== '') {
        return true;
    }

    return false;
};

export const isStringNotEmptyOrZeroLength = (value) => {
    if (isNotNullOrUndefined(value) && value !== '' && value.length > 0) {
        return true;
    }

    return false;
};

export const isListEmpty = (list) => {
    if (list === undefined || list === null || (isNotNullOrUndefined(list) && list.length === 0)) {
        return true;
    }

    return false;
};

export const isListNotEmpty = (list) => {
    if (isArrayLikeObject(list) && isNotNullOrUndefined(list) && list.length > 0) {
        return true;
    }

    return false;
};

export const isListLongerThanZero = (list) => {
    if (isArrayLikeObject(list) && isNotNullOrUndefined(list) && list.length > 0) {
        return true;
    }

    return false;
};

export const isListLongerThanOne = (list) => {
    if (isArrayLikeObject(list) && isNotNullOrUndefined(list) && list.length > 1) {
        return true;
    }

    return false;
};

export const isObjectEmpty = (obj) => {
    if (obj === undefined || obj === null || (isNotNullOrUndefined(obj) && isEmpty(obj))) {
        return true;
    }

    return false;
};

export const isObjectNotEmpty = (obj) => {
    if (isNotNullOrUndefined(obj) && !isEmpty(obj)) {
        return true;
    }

    return false;
};

export const isMomentDate = (value) => {
    if (isNotNullOrUndefined(value) && moment.isMoment(value)) {
        return true;
    }

    return false;
};

export const isNumberNotEmpty = (value) => {
    if (isNotNullOrUndefined(value) && isNumber(value)) {
        return true;
    }

    return false;
};

export const isNumberEmpty = (value) => {
    if (isNotNullOrUndefined(value)) {
        return false;
    }

    return true;
};

export const isNumberEmptyOrZero = (value) => {
    if (isNumberEmpty(value) || (isNumber(value) && value === 0)) {
        return true;
    }

    return false;
};

export const isNumberGreaterThanOrEqualToZero = (value) => {
    if (isNotNullOrUndefined(value) && isNumber(value) && value >= 0) {
        return true;
    }

    return false;
};

export const isNumberGreaterThanZero = (value) => {
    if (isNotNullOrUndefined(value) && isNumber(value) && value > 0) {
        return true;
    }

    return false;
};

export const isNumberLessThanOrEqualToZero = (value) => {
    if (isNotNullOrUndefined(value) && isNumber(value) && value <= 0) {
        return true;
    }

    return false;
};

export const isTrueLike = (value) => {
    if (isNotNullOrUndefined(value)) {
        if (typeof value === 'boolean' && value === true) {
            return true;
        } else if (typeof value === 'string' && (value === 'true' || value === 'True' || value === '1' || value === 'Yes' || value === 'yes' || value === 'YES')) {
            return true;
        } else if (typeof value === 'number' && value === 1) {
            return true;
        }
    }

    return false;
};

export const isFalseLike = (value) => {
    if (isNotNullOrUndefined(value)) {
        if (typeof value === 'boolean' && value === false) {
            return true;
        } else if (typeof value === 'string' && (value === 'false' || value === 'False' || value === '0' || value === 'No' || value === 'no' || value === 'NO')) {
            return true;
        } else if (typeof value === 'number' && value === 0) {
            return true;
        }
    }

    return false;
};

export const isBooleanTrue = (value) => {
    if (isNotNullOrUndefined(value) && isTrueLike(value)) {
        return true;
    }

    return false;
};

export const isBooleanFalse = (value) => {
    if (isNotNullOrUndefined(value) && isFalseLike(value)) {
        return true;
    }

    return false;
};

export const convertStringToFloatOrZero = (value) => {
    try {
        if (isNumberNotEmpty(value)) {
            return isNaN(parseFloat(value)) ? 0 : parseFloat(value);
        }
    } catch (error) {
        // console.log(error.message);
    }

    return 0;
};

export const convertStringToIntOrZero = (value) => {
    try {
        if (isNumberNotEmpty(value)) {
            return isNaN(parseInt(value)) ? 0 : parseInt(value);
        }
    } catch (error) {
        // console.log(error.message);
    }

    return 0;
};

export const convertStringToObject = (value) => {
    try {
        if (isStringNotEmpty(value)) {
            return JSON.parse(value);
        }
    } catch (error) {
        // console.log(error.message);
    }

    return null;
};

export const equals = (a, b) => {
    return a.length === b.length && a.every((v, i) => v === b[i]);
};

export const equalsIgnoreOrder = (a, b) => {
    if (a.length !== b.length) return false;
    const uniqueValues = new Set([...a, ...b]);
    for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
    }

    return true;
};

// removes a single (the first) instance of a value from an array
export const removeValueFromArray = (arr, value) => {
    if (isListNotEmpty(arr) && isNotNullOrUndefined(value)) {
        const index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
    }

    return arr;
};

// removes all instances of the value from the array
export const removeAllValueFromArray = (arr, value) => {
    let i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }

    return arr;
};

// returns an updated array with all instances of the value removed
export const filterOutValueFromArray = (arr, value) => {
    let updatedArr = [];
    if (isListNotEmpty(arr) && isNotNullOrUndefined(value)) {
        updatedArr = arr.filter(i => i !== value);
    }

    return updatedArr;
};

// returns an updated array with all instances of the values to remove, removed
export const filterOutValuesFromArray = (arr, valuesToRemove) => {
    let updatedArr = [];
    if (isListNotEmpty(arr) && isListNotEmpty(valuesToRemove)) {
        updatedArr = arr.filter(i => !valuesToRemove.includes(i));
    }

    return updatedArr;
};

export const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key => {
        if (!moment.isMoment(obj[key])) {
            if (obj[key] && typeof obj[key] === 'object' && Object.keys(obj[key]).length > 0) removeEmpty(obj[key]);
            else if (obj[key] === undefined) delete obj[key];
            else if (obj[key] === "") delete obj[key];

            if (obj[key] && typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) delete obj[key];
        }
    });

    return obj;
};

export const removeEmptyAndNull = (obj) => {
    Object.keys(obj).forEach(key => {
        if (!moment.isMoment(obj[key])) {
            if (obj[key] && typeof obj[key] === 'object' && Object.keys(obj[key]).length > 0) removeEmptyAndNull(obj[key]);
            else if (obj[key] === undefined) delete obj[key];
            else if (obj[key] === "") delete obj[key];
            else if (obj[key] === null) delete obj[key];

            if (obj[key] && typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0) delete obj[key];
        }
    });

    return obj;
};

export const convertToObject = (data) => {
    let obj = {};
    let t;
    let parts;
    let part;

    for (let k in data) {
        t = obj;
        parts = k.split('.');
        var key = parts.pop();
        while (parts.length) {
            part = parts.shift();
            t = t[part] = t[part] || {};
        }
        t[key] = data[k]
    }

    return obj;
};

export const isEquivalent = (a, b) => {
    // Create arrays of property names
    if (isObjectEmpty(a) && isObjectNotEmpty(b)) {
        return false;
    } else if (isObjectNotEmpty(a) && isObjectEmpty(b)) {
        return false;
    } else if (isObjectEmpty(a) && isObjectEmpty(b)) {
        return true;
    } else {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);

        // console.log(aProps);
        // console.log(bProps);
        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length !== bProps.length) {
            return false;
        }

        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];

            // console.log(a[propName]);
            // console.log(b[propName]);
            // If values of same property are not equal,
            // objects are not equivalent
            if (a[propName] !== b[propName]) {
                return false;
            }
        }

        // If we made it this far, objects
        // are considered equivalent
        return true;
    }
};

//get chunk from array
export const chunk = (arr, chunkSize = 1, cache = []) => {
    const tmp = [...arr];
    if (chunkSize <= 0) return cache;
    while (tmp.length) cache.push(tmp.splice(0, chunkSize));
    return cache;
};

export const isObjectNotEmptyWithoutEmptyParams = (obj) => {
    return isObjectNotEmpty(obj) && !isEmptyObjectWithEmptyParams(obj);
};

export const isEmptyObjectWithEmptyParams = (obj) => {
    if (Object.keys(obj).length === 0) {
        return true; // Object is empty
    }

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];

            if (value === null || value === undefined ||
                (typeof value === 'string' && value.trim() === '') ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === 'object' && isEmptyObjectWithEmptyParams(value))) {
                // Continue checking other properties
            } else {
                return false; // Found a non-empty parameter
            }
        }
    }

    return true; // All parameters are empty
};